import type { Invoice } from '../types';

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const getNextInvoiceNumber = (invoices: Invoice[], prefix: string, fallback: number): string => {
  const safePrefix = String(prefix || 'INV').trim() || 'INV';
  const pattern = new RegExp(`^${escapeRegExp(safePrefix)}-(\\d+)$`, 'i');
  let highest = Number.isFinite(fallback) ? Math.floor(fallback) - 1 : 1000;

  for (const invoice of invoices) {
    const match = String(invoice.invoiceNumber || '').trim().match(pattern);
    if (!match) continue;
    const value = Number(match[1]);
    if (Number.isFinite(value)) highest = Math.max(highest, value);
  }

  return `${safePrefix}-${String(highest + 1).padStart(4, '0')}`;
};